var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nerve-button',{class:{ 'ma-0': _vm.isLocalUi },attrs:{"id":"iiotUpdateDeployedWorkloadDialog","text":_vm.$t('nodes.deployedWorkloadControl.updateBtn'),"type-of-btn":"action","size":"normal"},on:{"click-event":_vm.updateBtnClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }